/**
 * Settings UI feature flags.
 *
 * Flip these to expose shipped-but-not-yet-released settings pages.
 * See docs/GENERAL-SIDECOST-GROUPS-GO-LIVE.md for go-live steps.
 */
export const GENERAL_SIDECOST_GROUPS_UI_ENABLED = false;
